import {
  ExpandOutlined,
  LogoutOutlined,
  MoonOutlined,
  ShrinkOutlined,
  SunOutlined,
} from '@ant-design/icons'
import { useTheme } from '@contexts/ThemeContext'
import { Admin, initials } from '@models/Admin'
import { Role, roleNameDictionary } from '@models/Role'
import { useAuth } from '@modules/auth/contexts/Auth'
import SearchDialog from '@modules/search-dialog'
import {
  Avatar,
  Button,
  Divider,
  Dropdown,
  Flex,
  Segmented,
  Space,
  Tag,
  theme,
  Typography,
} from 'antd'
import Gleap from 'gleap'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const { Text } = Typography

const RightHeader = () => {
  const { token } = theme.useToken()
  const navigate = useNavigate()

  const { currentUser, logout } = useAuth<Admin, {}>()
  const { toggleTheme, mode, toggleLayout, layoutMode } = useTheme()

  const contentStyle: React.CSSProperties = {
    backgroundColor: token.colorBgContainer,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  }

  return (
    <Space size={12}>
      <Button
        style={{ paddingLeft: 5, paddingRight: 5 }}
        type="text"
        onClick={() => navigate('/help')}
      >
        Help
      </Button>
      <Button
        style={{ paddingLeft: 5, paddingRight: 5 }}
        type="text"
        onClick={() => Gleap.openNews(true)}
      >
        <Text>Changelog</Text>
      </Button>
      <SearchDialog.Button />
      <Dropdown
        arrow
        placement="bottomRight"
        styles={{
          root: {
            minWidth: 230,
            right: '10px',
            maxWidth: 450,
          },
        }}
        popupRender={(menu) => (
          <Flex vertical style={contentStyle}>
            <Flex style={{ padding: 16 }} align="center" gap={8}>
              <Avatar
                style={{
                  color: '#fff',
                  backgroundColor: '#8e978a',
                  cursor: 'pointer',
                }}
              >
                {currentUser && initials(currentUser)}
              </Avatar>
              <Flex vertical align="start">
                <Text strong>
                  {currentUser?.firstName} {currentUser?.lastName}
                </Text>
                <Space wrap>
                  {currentUser?.roles.map((role) => (
                    <Tag>
                      {roleNameDictionary[(role as unknown as Role).name]}
                    </Tag>
                  ))}
                </Space>
              </Flex>
            </Flex>
            <Divider style={{ margin: 0 }} />
            <Flex vertical style={{ padding: 10 }} gap={10}>
              <Segmented
                block
                value={mode}
                onChange={toggleTheme}
                options={[
                  {
                    label: (
                      <>
                        <SunOutlined /> Light
                      </>
                    ),
                    value: 'light',
                  },
                  {
                    label: (
                      <>
                        <MoonOutlined /> Dark
                      </>
                    ),
                    value: 'dark',
                  },
                ]}
              />
              <Segmented
                block
                value={layoutMode}
                onChange={toggleLayout}
                options={[
                  {
                    label: (
                      <>
                        <ShrinkOutlined /> Default
                      </>
                    ),
                    value: 'default',
                  },
                  {
                    label: (
                      <>
                        <ExpandOutlined /> Large
                      </>
                    ),
                    value: 'large',
                  },
                ]}
              />
              <Button
                icon={<LogoutOutlined />}
                danger
                type="primary"
                className="w-full"
                onClick={logout}
              >
                Logout
              </Button>
            </Flex>
          </Flex>
        )}
      >
        <Avatar
          style={{
            marginBottom: 4,
            color: '#fff',
            backgroundColor: '#8e978a',
            cursor: 'pointer',
          }}
        >
          {currentUser && initials(currentUser)}
        </Avatar>
      </Dropdown>
    </Space>
  )
}

export default RightHeader
